import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import {
  PrismBreadcrumb,
  PrismButton,
  PrismTooltip,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';
import HotelBenchmarkInsightCompetitorsCompetitorsPanel from 'lumen/components/hotel/benchmark-insight/competitors/competitors-panel';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsCompetitorsBenchmarkController from 'lumen/controllers/hotel/settings/competitors/benchmark';

interface HotelSettingsCompetitorsBenchmarkSignature {
  Args: {
    controller: HotelSettingsCompetitorsBenchmarkController;
    model: unknown;
  };
}

<template>
  {{! @glint-nocheck: not typesafe yet }}
  <SettingsPageTemplate
    @badge={{t "general.benchmark_insight"}}
    @isFullHeight={{true}}
    @title={{@controller.pageTitle}}
  >
    <:breadcrumb>
      <PrismBreadcrumb as |B|>
        <B.item
          @label={{t "general.competitors"}}
          @route="hotel.settings.competitors"
        />
        <B.item @isCurrent={{true}} @label={{@controller.pageTitle}} />
      </PrismBreadcrumb>
    </:breadcrumb>

    <:headerAfter>
      {{#unless (or @controller.showOldCompsetContent @controller.isLoading)}}
        {{#if @controller.access.hasBenchmarkInsightSettingsCompsetEdit}}
          <div data-test-id="button-compset-edit-wrapper">
            <PrismButton
              @buttonType="secondary"
              @isDisabled={{@controller.isButtonEditCompsetDisabled}}
              @label={{@controller.buttonEditCompsetLabel}}
              data-test-id="button-compset-edit"
              {{on "click" @controller.onClickEditCompset}}
            />

            {{#if @controller.buttonEditCompsetDisabledTooltip}}
              <PrismTooltip
                @side="left"
                @text={{@controller.buttonEditCompsetDisabledTooltip.description}}
                @title={{@controller.buttonEditCompsetDisabledTooltip.title}}
              />
            {{/if}}
          </div>
        {{/if}}
      {{/unless}}
    </:headerAfter>

    <:default>
      {{#if @controller.showOldCompsetContent}}
        <HotelBenchmarkInsightCompetitorsCompetitorsPanel
          @activeTab={{@controller.activeTab}}
          @compset={{@controller.competitors}}
          @isLoading={{@controller.isLoading}}
          @setActiveTab={{@controller.setActiveTab}}
          @smartCompset={{@controller.smartCompset}}
        >
          {{outlet}}
        </HotelBenchmarkInsightCompetitorsCompetitorsPanel>
      {{else}}
        {{outlet}}
      {{/if}}
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsCompetitorsBenchmarkSignature>;
